import { render } from "./CookiesImageViewer.vue?vue&type=template&id=2eb3197b&scoped=true"
import script from "./CookiesImageViewer.vue?vue&type=script&lang=js"
export * from "./CookiesImageViewer.vue?vue&type=script&lang=js"

import "./CookiesImageViewer.vue?vue&type=style&index=0&id=2eb3197b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb3197b"]])

export default __exports__